import { Box, Button, FormControl, Grid, MenuItem, TextField, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AuthContext } from '../../libs/contexts/authContext'
import { filterNonDigits, isValidPhoneNumber, phoneNumberFormatter } from '../../libs/utils'
import { getAffiliateInfo } from '../../store/actions/authActions'
import { getZipCodes, states, whichStates } from './utils'

export default function SecondRegisterStep({
  registrationForm,
  setRegistrationForm,
  handleRegistrationFormChange,
  workAddress,
  setWorkAddress,
  handleNext,
}) {
  const dispatch = useDispatch()
  const userSourceCode = useSelector((state) => state.auth.userSourceCode)
  const { workAgentPhone, agent_id } = registrationForm
  const { address1, address2, city, zipCode, state } = workAddress
  const {productId} = useContext(AuthContext)
  // const {
  //   affiliateCode,
  //   invalidUrl,
  //   orgObject: { orgName },
  // } = useContext(AuthContext)
  // const [distributorId, setDistributorId] = useState('userSourceCode') //temp fix
  const [distributorId, setDistributorId] = useState( productId === '81403' ? '8198' : '8973')
  const [orgName, setOrgName] = useState( productId === '81403' ? 'Milner' : 'Quility')
  const [errorTree, setErrorTree] = useState({
    phoneNumber: false,
    zipCode: false,
    address1: false,
    city: false,
    state: false,
  })

  // useEffect(() => {
  //   const populateWorkAddress = async () => {
  //     const input = {
  //       userSourceCode,
  //       affiliateCode,
  //     }
  //     const res = await dispatch(getAffiliateInfo(input))
  //     if (res.statusCode === 200) {
  //       setRegistrationForm((prev) => ({
  //         ...prev,
  //         firstName: res.firstName || prev.firstName,
  //         lastName: res.lastName || prev.lastName,
  //         workAgentPhone: res.workAgentPhone || prev.workAgentPhone,
  //       }))
  //       setWorkAddress((prev) => ({
  //         ...prev,
  //         city: res.workAgentCity || prev.city,
  //         state: res.workAgentState || prev.state,
  //         address1: res.workAgentStreet1 || prev.address1,
  //         address2: res.workAgentStreet2 || prev.address2,
  //         zipCode: res.workAgentZip || prev.zipCode,
  //       }))
  //     }
  //   }
  //   if (!invalidUrl) {
  //     populateWorkAddress()
  //   }
  // }, [affiliateCode, userSourceCode, invalidUrl, setRegistrationForm, setWorkAddress, dispatch])

  useEffect(() => {
    if (zipCode !== '' && zipCode.length < 5) {
      setErrorTree((prev) => ({ ...prev, zipCode: true }))
      return
    }
    const validateZipCode = () => {
      const statesArr = whichStates(zipCode)
      if (statesArr.findIndex((s) => s === state) === -1) {
        setErrorTree((prev) => ({ ...prev, zipCode: true }))
        return
      }
      const targetCodes = getZipCodes(state)
      setErrorTree((prev) => ({
        ...prev,
        zipCode: targetCodes.findIndex((c) => c === zipCode) === -1,
      }))
    }
    if (state) {
      validateZipCode()
    }
  }, [state, zipCode])

  const handleFormChange = ({ target: { name, value } }) => {
    switch (name) {
      case 'zipCode':
        const filteredZipCode = filterNonDigits(value)
        if (filteredZipCode.length === 5) {
          setErrorTree((prev) => ({ ...prev, zipCode: false }))
        }
        setWorkAddress((prev) => ({ ...prev, zipCode: filteredZipCode }))
        break
      default:
        setWorkAddress((prev) => ({ ...prev, [name]: value }))
        break
    }
  }

  const handleBlur = ({ target: { name, value } }) => {
    switch (name) {
      case 'address2':
        break
      case 'workAgentPhone':
        setErrorTree((prev) => ({
          ...prev,
          phoneNumber: !isValidPhoneNumber(workAgentPhone),
        }))
        break
      default:
        setErrorTree((prev) => ({ ...prev, [name]: value.trim() === '' }))
        break
    }
  }

  const formIsComplete = Object.entries(workAddress)
    .filter(([k, _v]) => k !== 'address2')
    .every(([_k, v]) => v.trim() !== '')
  const errorFree = Object.values(errorTree).every((v) => v === false)

  return (
    <Box component="form" sx={{ '& .MuiTextField-root': { m: 1 } }} noValidate autoComplete="off">
      <Typography align={'left'} sx={registerStepStyle.subheading}>
        Company Information
      </Typography>{' '}
      <Grid container spacing={2}>
        {' '}
        <Grid item lg={6} md={6} sm={6} xs={12}>
          {' '}
          <TextField
            id="outlined-disabled"
            label="Distributor ID"
            value={distributorId}
            onChange={(e) => setDistributorId(e.target.value)}
            placeholder="Distributor ID"
            InputProps={{ readOnly: true }}
            InputLabelProps={{ shrink: true }}
            sx={registerStepStyle.textField}
            required
            disabled={true}
          />{' '}
        </Grid>{' '}
        <Grid item lg={6} md={6} sm={6} xs={12} justify="center" alignItems="center">
          {' '}
          <TextField
            id="outlined-disabled"
            label="Organization Name"
            value={orgName}
            placeholder="ex. Lorem Co."
            InputProps={{ readOnly: true }}
            InputLabelProps={{ shrink: true }}
            sx={registerStepStyle.textField}
            disabled={true}
          />{' '}
        </Grid>{' '}
        <Grid item lg={6} md={6} sm={6} xs={12}>
          {' '}
          <TextField
            id="outlined-disabled"
            label="Agent ID"
            value={agent_id}
            placeholder="Agent ID"
            InputProps={{ readOnly: true }}
            InputLabelProps={{ shrink: true }}
            sx={registerStepStyle.textField}
            required
            disabled={true}
          />{' '}
        </Grid>{' '}
      </Grid>{' '}
      <Typography align={'left'} sx={registerStepStyle.subheading}>
        Contact Information
      </Typography>
      <Grid container spacing={2}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <FormControl fullWidth>
            <TextField
              id="outlined-disabled"
              name="workAgentPhone"
              label="Phone Number"
              placeholder="ex. 000-000-000"
              InputLabelProps={{ shrink: true }}
              sx={registerStepStyle.textField}
              value={phoneNumberFormatter(workAgentPhone)}
              onChange={handleRegistrationFormChange}
              onBlur={handleBlur}
              error={errorTree.phoneNumber}
              helperText={errorTree.phoneNumber ? 'Please enter a valid phone number' : ''}
              inputProps={{ maxLength: 10 }}
              required
            />
          </FormControl>
        </Grid>
      </Grid>
      <Typography align={'left'} sx={registerStepStyle.subheading}>
        Work Address
      </Typography>
      <Grid container spacing={2}>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <TextField
            id="outlined-disabled"
            label="Zip Code"
            placeholder="ex. 33101"
            InputLabelProps={{ shrink: true }}
            sx={registerStepStyle.textField}
            required
            name="zipCode"
            value={zipCode}
            onChange={handleFormChange}
            error={errorTree.zipCode}
            helperText={errorTree.zipCode ? 'Invalid zip code' : ''}
            inputProps={{ maxLength: 5 }}
          />
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12} justify="center" alignItems="center">
          <TextField
            id="outlined-disabled"
            label="Address 1"
            placeholder="ex. 1234 Chance Rd."
            InputLabelProps={{ shrink: true }}
            sx={registerStepStyle.textField}
            required
            name="address1"
            value={address1}
            onChange={handleFormChange}
            onBlur={handleBlur}
            error={errorTree.address1}
            helperText={errorTree.address1 ? 'Address 1 is required' : ''}
          />
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <TextField
            id="outlined-disabled"
            label="Address 2"
            name="address2"
            value={address2}
            onChange={handleFormChange}
            placeholder="ex. Apt 111"
            InputLabelProps={{ shrink: true }}
            sx={registerStepStyle.textField}
          />
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <TextField
            id="outlined-disabled"
            label="City"
            placeholder="ex. Miami"
            InputLabelProps={{ shrink: true }}
            sx={registerStepStyle.textField}
            required
            name="city"
            value={city}
            onChange={handleFormChange}
            onBlur={handleBlur}
            error={errorTree.city}
            helperText={errorTree.city ? 'City is required' : ''}
          />
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <TextField
            select
            label="State"
            name="state"
            value={state}
            onChange={handleFormChange}
            required
            sx={registerStepStyle.textField}
            onBlur={handleBlur}
            error={errorTree.state}
            helperText={errorTree.state ? 'State is required' : ''}
          >
            {states.map((stateVal, index) => (
              <MenuItem key={index} value={stateVal}>
                {stateVal}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
      <Button sx={registerStepStyle.nextButton} onClick={handleNext} disabled={!formIsComplete || !errorFree}>
        Next
      </Button>
    </Box>
  )
}

const registerStepStyle = {
  verifyButton: {
    textTransform: 'none',
    width: { lg: '90%', md: '90%', sm: '90%', xs: '60%' },
    height: '40px',
    mt: { sm: '15px', xs: '0px' },
    backgroundColor: '#C4CAF1',
    color: '#3C4FB9',
    borderRadius: '100px',
    '&:hover': {
      backgroundColor: '#9BA5DF',
      color: '#36414E',
    },
    '&:disabled': {
      backgroundColor: '#C4CAF1',
      color: 'white',
      textTransform: 'none',
    },
  },

  nextButton: {
    textTransform: 'none',
    width: { lg: '50%', md: '50%', sm: '50%', xs: '60%' },
    height: '40px',
    backgroundColor: '#3C4FB9',
    color: 'white',
    borderRadius: '100px',
    mt: '10px',
    '&:hover': {
      backgroundColor: '#9BA5DF',
      color: '#36414E',
    },
    '&:disabled': {
      backgroundColor: '#C4CAF1',
      color: 'white',
      textTransform: 'none',
    },
  },

  textField: {
    backgroundColor: 'white',
    width: '100%',
    textAlign: 'left',
  },

  subheading: {
    padding: '30px 0px 15px 0px',
  },
}
